import { EnumBuilder } from '@mntn-dev/utility-types'
import type { ZodSimplify } from '@mntn-dev/utility-types'

export const [Units, UnitSchema, UnitMap] = EnumBuilder(
  'mntn_credits',
  'tiktok',
  'meta',
  'linkedin',
  'USD'
)

export type Unit = ZodSimplify<typeof UnitSchema>
